<template>
    <div class="success-box">
        <base-header></base-header>
        <div class="msg-box">
            <p>支付成功！酒币已到账</p>
            <p>
                <span>遇到充值未到账？可联系平台在线客服</span>
            </p>
            <base-button :name="`好的，回到个人中心`" class="ok-btn" @click="backToMain"></base-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'success-pay',
    data() {
        return {
           
        }
    },
    created() {},
    methods: {
        backToMain() {
            this.$router.push('/');
        },
    },
}
</script>
<style lang="scss" scoped>
.success-box {
    width: 100%;
    height: 100vh;
    position: relative;
    .msg-box {
        width: 100%;
        height: 1rem;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        p {
            width: 100%;
            color: #00a408;
            font-size: 0.62rem;
            // height: 0.6rem;
            line-height: 0.6rem;
            text-align: center;
            font-weight: bold;
            span {
                color: #ff0000;
                font-size: 0.22rem;
                font-weight: normal;
                display: block;
                margin-top: 0.1rem;
                height: .23rem;
                line-height: .23rem;
                margin-top: .3rem;
            }
        }
        .ok-btn{
            margin-top: .9rem;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/success_pay.vue